import { render, staticRenderFns } from "./GetTenants.vue?vue&type=template&id=4e748787&scoped=true"
import script from "./GetTenants.vue?vue&type=script&lang=js"
export * from "./GetTenants.vue?vue&type=script&lang=js"
import style0 from "./GetTenants.vue?vue&type=style&index=0&id=4e748787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e748787",
  null
  
)

export default component.exports